import {SvgFactory, SvgFactoryConfig} from './lib/svg-factory';

let config = new SvgFactoryConfig();
config.iconName = "share-email";
config.viewBox="0 0 35 23";
config.shape = `
    <g fill="var(--fill)" fill-rule="nonzero">
        <path d="M17.772 14.94L34.186.89a1.763 1.763 0 0 0-.945-.301H2.304c-.344 0-.688.129-.946.3L17.772 14.94z"/>
        <path d="M18.89 16.23a1.7 1.7 0 0 1-2.235 0L.585 2.521v17.832c0 .946.773 1.72 1.719 1.72H33.24c.945 0 1.719-.774 1.719-1.72V2.48L18.89 16.23z"/>
    </g>
`;
let ShareEmailSVG = new SvgFactory(config);

export default ShareEmailSVG;

